import { render } from "./EditTariffZone.vue?vue&type=template&id=5a41bfc6&ts=true"
import script from "./EditTariffZone.vue?vue&type=script&lang=ts"
export * from "./EditTariffZone.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__